module.exports = angular.module('cartographer.app.form.datetime', [])

moment = require 'moment'

# Datetime field widget. Intended usage:
#
#   <div crt-datetime-field model="survey.recorded" id="id" class="class"></div>
module.exports.directive 'crtDatetimeField', $DI (crtLog, crtDatetime) ->
  return {
    restrict: 'A'
    require: [ 'ngModel', '^?crtForm' ]
    link: ($scope, element, attrs, controllers) ->
      [ ngModel, crtForm ] = controllers

      element.attr('placeholder', attrs.placeholder ? crtDatetime.displayFormat.toLowerCase())

      ngModel.$formatters.push (date) ->
        if date
          crtDatetime.format(date)
        else
          ""

      ngModel.$parsers.push (text) ->
        if text == '' || !text
          ngModel.$setValidity('datetime', true)
          null
        else
          date = crtDatetime.parse(text)
          if date
            ngModel.$setValidity('datetime', true)
            date
          else
            ngModel.$setValidity('datetime', false)
            null

      return
  }

# Datetime field widget. Intended usage:
#
#   <div crt-datetime-field model="survey.recorded" id="id" class="class"></div>
module.exports.directive 'crtDateField', $DI (crtLog, crtDatetime) ->
  return {
    restrict: 'A'
    require: [ 'ngModel', '^?crtForm' ]
    link: ($scope, element, attrs, controllers) ->
      [ ngModel, crtForm ] = controllers

      element.attr('placeholder', 'dd/mm/yyyy')

      savedTime = ''

      ngModel.$formatters.push (date) ->
        if date
          savedTime = crtDatetime.format(date, 'HH:mm')
          crtDatetime.format(date, 'DD/MM/YYYY')
        else
          savedTime = '12:00'
          ""

      ngModel.$parsers.push (text) ->
        if text == '' || !text
          ngModel.$setValidity('datetime', true)
          null
        else
          date = crtDatetime.parse([ text, savedTime ].join(' '))
          if date
            ngModel.$setValidity('datetime', true)
            date
          else
            ngModel.$setValidity('datetime', false)
            null

      return
  }

# Datetime field widget. Intended usage:
#
#   <div crt-time-field model="survey.recorded" id="id" class="class"></div>
module.exports.directive 'crtTimeField', $DI (crtLog, crtDatetime) ->
  return {
    restrict: 'A'
    require: [ 'ngModel', '^?crtForm' ]
    link: ($scope, element, attrs, controllers) ->
      [ ngModel, crtForm ] = controllers

      element.attr('placeholder', 'hh:mm (24 hour)')

      savedDate = ''

      ngModel.$formatters.push (date) ->
        if date
          savedDate = crtDatetime.format(date, 'DD/MM/YYYY')
          crtDatetime.format(date, 'HH:mm')
        else
          savedTime = crtDatetime.format(new Date, 'DD/MM/YYYY')
          ""

      ngModel.$parsers.push (text) ->
        if text == '' || !text
          ngModel.$setValidity('datetime', true)
          null
        else
          date = crtDatetime.parse([ savedDate, text ].join(' '))
          if date
            ngModel.$setValidity('datetime', true)
            date
          else
            ngModel.$setValidity('datetime', false)
            null

      return
  }

# Datetime field widget. Intended usage:
#
#   <div crt-separate-datetime-field model="survey.recorded" id="id" class="class"></div>
module.exports.directive 'crtSeparateDatetimeField', $DI (crtLog, crtString, crtDatetime, crtFormUtil) ->
  return {
    restrict: 'A'
    require: [ 'ngModel', '^?crtForm' ]
    template: require './separate-datetime-field.tpl.html'
    link: ($scope, element, attrs, controllers) ->
      [ ngModel, crtForm ] = controllers

      element.attr('placeholder', 'hh:mm (24 hour)')

      $scope.name = crtFormUtil.parseInputName($scope, crtForm, attrs.name ? attrs.ngModel)

      $scope.strings = {
        date: null
        time: null
      }

      # Duplicate of code from crtInputDirective:
      $scope.$emit('form:inputAdded', $scope.name)

      modelUpdated = ->
        date = ngModel.$modelValue
        crtLog.debug('modelUpdated', date)

        dateString = if date then crtDatetime.format(date, 'DD/MM/YYYY') else null
        timeString = if date then crtDatetime.format(date, 'HH:mm')      else null

        dateSame = crtDatetime.parseDate(dateString)?.getTime() == crtDatetime.parseDate($scope.strings.date)?.getTime()
        timeSame = crtDatetime.parseTime(timeString)?.getTime() == crtDatetime.parseTime($scope.strings.time)?.getTime()

        if dateString && !dateSame then $scope.strings.date = dateString
        if timeString && !timeSame then $scope.strings.time = timeString

        return

      viewUpdated = ->
        dateString = crtString.trimToNull($scope.strings.date)
        timeString = crtString.trimToNull($scope.strings.time)
        crtLog.debug('viewUpdated', dateString, timeString)
        if dateString && timeString
          date     = crtDatetime.parseDate(dateString)
          time     = crtDatetime.parseTime(timeString)
          if date && time
            ngModel.$setValidity('datetime', true)
            ngModel.$setViewValue(crtDatetime.parse([ dateString, timeString ].join(" ")))
          else
            ngModel.$setValidity('datetime', false)
            ngModel.$setViewValue(null)
        else if dateString || timeString
          ngModel.$setValidity('datetime', false)
          ngModel.$setViewValue(null)
        else
          ngModel.$setValidity('datetime', true)
          ngModel.$setViewValue(null)

        # Duplicate of code from crtInputDirective:
        errors = for key, value of ngModel.$error when value
          { level: "error", field: $scope.name, message: crtFormUtil.parseError(key) }
        $scope.$emit('form:inputUpdated', $scope.name, errors)

        return

      $scope.$watch((-> ngModel.$modelValue), modelUpdated)
      $scope.$watch('strings', viewUpdated, true)

      return
  }

# Datetime field widget. Intended usage:
#
#   <input crt-relative-time-field
#          start-time="survey.recorded"
#               model="survey.otherTime">
#
# Time field that returns a datetime within 24 hours of a start time specified in another
# part of the model. For example:
#
#         START TIME        THIS VALUE      RESULT
#         01/01/2014 21:00  22:00           01/01/2014 22:00
#         01/01/2014 21:00  20:00           02/01/2014 20:00
#
# Used for surveys like radiotracking where the activity runs over midnight but re-rentering
# the date every time is arduous.
#
# This is a hacky directive. Because ngModel grabs an isolated scope on the <input> element,
# we can't grab startTime using isolated scope. We use $scope.$parent[attrs.startTime] instead,
# and we place a on $scope.$parent to update the ngModel whenever the startTime changes.
module.exports.directive 'crtRelativeTimeField', $DI (crtLog, crtDatetime, $parse) ->
  return {
    restrict: 'A'
    require: [ 'ngModel', '^?crtForm' ]
    link: ($scope, element, attrs, controllers) ->
      [ ngModel, crtForm ] = controllers

      getStart = ->
        $parse(attrs.startTime)($scope.$parent)

      element.attr('placeholder', 'hh:mm')

      format = (date) ->
        if date
          crtDatetime.format(date, 'HH:mm')
        else
          ''

      parse = (text) ->
        if text == '' || !text
          ngModel.$setValidity('time', true)
          null
        else
          date = crtDatetime.parse(text, [ 'HH:mm' ])
          if date
            ngModel.$setValidity('time', true)

            date  = moment(date)
            start = moment(getStart() ? new Date())

            timeOffset  = 60 *  date.hours() +  date.minutes()
            startOffset = 60 * start.hours() + start.minutes()

            if timeOffset < startOffset
              start.hours(date.hours()).add("days", 1).minutes(date.minutes()).toDate()
            else
              start.hours(date.hours()).minutes(date.minutes()).toDate()
          else
            ngModel.$setValidity('time', false)
            null

      ngModel.$formatters.push(format)
      ngModel.$parsers.push(parse)

      $scope.$parent.$watch attrs.startTime, (startTime) ->
        crtLog.debug('crtRelativeTimeField.watch', startTime, format(ngModel.$modelValue), parse(format(ngModel.$modelValue)))
        if ngModel.$modelValue
          ngModel.$setViewValue(format(ngModel.$modelValue))
        return

      return
  }
